import { TAvailableConfigValues } from '@customTypes/common';

export interface ISwitchHistoryConfig {
  banResolutionDuration: number;
}

export const defaultSwitchHistoryConfig: ISwitchHistoryConfig = {
  banResolutionDuration: 7000,
};

export const availableSwitchHistoryConfigValues: TAvailableConfigValues<ISwitchHistoryConfig> = {};
